import { Styles } from '@chakra-ui/theme-tools';

const styles: Styles = {
  global: {
    body: {
      margin: 0,
      color: '#4A5568',
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },
    code: {
      fontFamily:
        'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace',
    },
  },
};

export default styles;
